import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(86347);
  return <div className="border-b border-night-600 bg-night-950" data-id="element-276" data-mp="8bib9jbsv6r1">
      <div className="mx-auto flex max-w-shell items-center justify-between gap-4 px-5 py-2.5 sm:px-6" data-id="element-277" data-mp="3hnjdsm1jlgv">
        <p className="min-w-0 truncate text-[11px] text-cream sm:text-sm" data-id="element-278" data-mp="3uo8g9sys1nlt">
          <span className="mr-1.5 font-bold uppercase tracking-wider text-amber" data-id="element-279" data-mp="3qny0xpp3hkua">Promocja</span>
          <span className="hidden sm:inline" data-id="element-280" data-mp="3lnsdklpuyki0">Pakiet 6 tomów + 6 darmowych bonusów — </span>
          tylko $27. Oferta kończy się dziś wieczorem.
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-281" data-mp="3grbg30wrqts9">
          <span className="hidden text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:inline" data-id="element-282" data-mp="3br79q3pkrffr">
            Koniec za
          </span>
          <span className="text-xs font-semibold tabular-nums text-amber sm:text-sm" data-id="element-283" data-mp="1evhtzu23a0p7">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}